import React from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import './TradeValidationCard.css';

/**
 * TradeValidationCard displays a saved trade specification
 * in a compact card format within the chat.
 */
const TradeValidationCard = ({ trade }) => {
  if (!trade) return null;

  const isLong = trade.direction === 'LONG';

  // Calculate R:R if we have entry, stop, and target
  const calculateRR = () => {
    if (!trade.entryPrice || !trade.stopPrice || !trade.targetPrice) return null;
    const entry = parseFloat(trade.entryPrice);
    const stop = parseFloat(trade.stopPrice);
    const target = parseFloat(trade.targetPrice);
    const risk = Math.abs(entry - stop);
    const reward = Math.abs(target - entry);
    if (risk === 0) return null;
    return (reward / risk).toFixed(1);
  };

  const rr = calculateRR();

  return (
    <div className="trade-validation-card saved">
      <div className="tvc-header">
        <div className="tvc-instrument-info">
          <span className="tvc-instrument">{trade.instrument || 'Unknown'}</span>
          <span className={`tvc-direction ${isLong ? 'long' : 'short'}`}>
            {isLong ? <TrendingUpIcon fontSize="inherit" /> : <TrendingDownIcon fontSize="inherit" />}
            {isLong ? 'LONG' : 'SHORT'}
          </span>
        </div>
        <div className="tvc-status saved">
          <SaveOutlinedIcon fontSize="small" />
          SAVED
        </div>
      </div>

      <div className="tvc-levels">
        <div className="tvc-level">
          <span className="tvc-level-label">Entry</span>
          <span className="tvc-level-value">{parseFloat(trade.entryPrice).toFixed(5)}</span>
        </div>
        <div className="tvc-level">
          <span className="tvc-level-label stop">Stop</span>
          <span className="tvc-level-value stop">{parseFloat(trade.stopPrice).toFixed(5)}</span>
        </div>
        {trade.targetPrice && (
          <div className="tvc-level">
            <span className="tvc-level-label target">Target</span>
            <span className="tvc-level-value target">{parseFloat(trade.targetPrice).toFixed(5)}</span>
          </div>
        )}
        {rr && (
          <div className="tvc-level">
            <span className="tvc-level-label">R:R</span>
            <span className="tvc-level-value highlight">{rr}</span>
          </div>
        )}
      </div>

      <div className="tvc-hint">
        Run validation in the Validate tab
      </div>
    </div>
  );
};

export default TradeValidationCard;
